<div class="capsule main">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h1>{{ 'ref-policies-title' | translate }}</h1>
    <button (click)="synchroSDS()" type="button" class="btn d-flex align-items-center reset">
      <img src="assets/icons/reset.svg">
      {{ 'ref-policies-synchro-sds' | translate }}
    </button>
  </div>
  @if (!loadingSDS()) {
  <div ngbAccordion>
    <div ngbAccordionItem="clientsItem" #clientsItem="ngbAccordionItem">
      <div ngbAccordionHeader>
        <button class="accordion-button">
          <div class="d-flex title justify-content-between align-items-center">
            <h2>{{ 'ref-policies-clients-title' | translate }}</h2>
            <div class="tags d-flex flex-row justify-content-around align-items-center">
              <app-form-ref-policies-settings [action]="'add-client-ref'" (addRefPolicy)="addRefPolicy($event)">
              </app-form-ref-policies-settings>
              <div class="tag d-flex flex-row justify-content-center">
                <h3 class="name total">{{ 'security-policies-details-total' | translate }}</h3>
                <h3 class="value">{{ listClientRefPolicies().length }}</h3>
              </div>
            </div>
          </div>
        </button>
      </div>
      <div ngbAccordionCollapse class="d-flex flex-wrap">
        <div ngbAccordionBody class="canevasList">
          @if (listClientRefPolicies().length > 0) {
          <ul>
            @for (refcli of listClientRefPolicies(); track $index) {
            <li class="d-flex flex-row justify-content-between align-items-center elem">
              <h3 class="name">{{ refcli.name }}</h3>
              <div class="d-flex flex-row justify-content-around align-items-center">
                <img id="clients" src="assets/icons/person.dark.svg">
                <h3 class="value">{{ refcli.client?.name }}</h3>
              </div>
              <div class="d-flex flex-row justify-content-between align-items-center icons">
                <app-form-ref-policies-settings [action]="'edit-client-ref'" [refPolicy]="refcli"
                  (patchRefPolicy)="patchRefPolicy($event)">
                </app-form-ref-policies-settings>
                <app-form-ref-policies-settings [action]="'delete'" [refPolicy]="refcli"
                  (deleteRefPolicy)="deleteRefPolicy($event)">
                </app-form-ref-policies-settings>
              </div>
            </li>
            }
          </ul>
          } @else {
          <div class="d-flex flex-row justify-content-around align-items-center noRefPolicies">
            <img id="notfound" src="assets/images/Components/notfoundalone.svg">
            <h3>{{ 'ref-policies-no-client-ref-found' | translate }}</h3>
          </div>
          }
        </div>
      </div>
    </div>

    <div ngbAccordionItem="defaultItem" #defaultItem="ngbAccordionItem">
      <div ngbAccordionHeader>
        <button class="accordion-button">
          <div class="d-flex title justify-content-between align-items-center">
            <h2>{{ 'ref-policies-default-title' | translate }}</h2>
            <div class="tags d-flex flex-row justify-content-around align-items-center">
              <app-form-ref-policies-settings [action]="'add-default-ref'" (addRefPolicy)="addRefPolicy($event)">
              </app-form-ref-policies-settings>
              <div class="tag d-flex flex-row justify-content-center">
                <h3 class="name total">{{ 'security-policies-details-total' | translate }}</h3>
                <h3 class="value">{{ listDefaultRefPolicies().length }}</h3>
              </div>
            </div>
          </div>
        </button>
      </div>
      <div ngbAccordionCollapse class="d-flex flex-wrap">
        <div ngbAccordionBody class="canevasList">
          @if (listDefaultRefPolicies().length > 0) {
          <ul>
            @for (refDefault of listDefaultRefPolicies(); track $index) {
            <li class="d-flex flex-row justify-content-between align-items-center elem">
              <h3 class="name">{{ refDefault.name }}</h3>
              <div class="d-flex flex-row justify-content-between align-items-center icons">
                <app-form-ref-policies-settings [action]="'edit-default-ref'" [refPolicy]="refDefault"
                  (patchRefPolicy)="patchRefPolicy($event)">
                </app-form-ref-policies-settings>
                <app-form-ref-policies-settings [action]="'delete'" [refPolicy]="refDefault"
                  (deleteRefPolicy)="deleteRefPolicy($event)">
                </app-form-ref-policies-settings>
              </div>
            </li>
            }
          </ul>
          } @else {
          <div class="d-flex flex-row justify-content-around align-items-center noRefPolicies">
            <img id="notfound" src="assets/images/Components/notfoundalone.svg">
            <h3>{{ 'ref-policies-no-default-ref-found' | translate }}</h3>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  } @else {
  @if (loadingSDS()) {
  <app-loading-error [boolean]="true" [message]="'waiting-for-synchro-sds' | translate"></app-loading-error>
  }
  }
</div>
<app-toast-component></app-toast-component>